import { defineComponent as _defineComponent } from 'vue'
import GPaidFeature from '@/components/g-paid-feature.vue'
import { USER_PERMISSION_KEY } from '@/data/auth'



export default /*#__PURE__*/_defineComponent({
  __name: 'g-drag-label',
  props: {
    labelList: null
  },
  emits: ['startDrag'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  labelList: Array<{
    title: string
    arr: Array<{ id: number; label_name_show: string }>
  }>
}

const THICK_MARK_LABEL = '大板厚度标识'

const thickMarkPermissionKeys = [USER_PERMISSION_KEY.BIG_PLANK_THICK_MARK]
const thickMarkIconStyle = { top: '-6px', right: '-8px', fontSize: '14px' }




function isThickMarkLabel(item: { label_name_show: string }): boolean {
  return item.label_name_show === THICK_MARK_LABEL
}

function handleStartDrag(event: any, item: any) {
  emits('startDrag', event, item)
}

return { __sfc: true,THICK_MARK_LABEL, thickMarkPermissionKeys, thickMarkIconStyle, props, emits, isThickMarkLabel, handleStartDrag, GPaidFeature }
}

})